module.exports = __webpack_public_path__ + "img/بیضی2.703f59eb.png";